import { lazy, Suspense, useState } from 'react';

import type { PersonBankAccountSheetProps } from './person-bank-account-sheet.types';

// Porta dos dados bancários da pessoa para outros módulos (unidade 10E): leve de propósito. O diálogo, o formulário e o
// fio só carregam na primeira vez que alguém abre (import dinâmico).

export type { PersonBankAccountSheetProps } from './person-bank-account-sheet.types';

const Sheet = lazy(() => import('./screens/person-bank-account-sheet').then((module) => ({ default: module.PersonBankAccountSheetContent })));

/**
 * Adicionar ou editar uma conta bancária da pessoa sem sair do fluxo (o drawer de dados bancários do Resumo da
 * simulação): lê a pessoa, mostra a prévia e grava só a conta escolhida; as outras contas ficam como estão.
 */
export function PersonBankAccountSheet(props: PersonBankAccountSheetProps) {
  const [used, setUsed] = useState(props.open);
  if (props.open && !used) setUsed(true);
  if (!used) return null;
  return (
    <Suspense fallback={null}>
      <Sheet {...props} />
    </Suspense>
  );
}
